import { render, staticRenderFns } from "./CreateCommentConfig.vue?vue&type=template&id=6a5d6950&scoped=true"
import script from "./CreateCommentConfig.vue?vue&type=script&lang=js"
export * from "./CreateCommentConfig.vue?vue&type=script&lang=js"
import style0 from "./CreateCommentConfig.vue?vue&type=style&index=0&id=6a5d6950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d6950",
  null
  
)

export default component.exports